import styled from 'styled-components';

export const Image = styled.img`
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height};
  margin: ${(props) => props.margin};
  padding: ${(props) => props.padding};
  cursor: ${(props) => props.cursor};
`;
